import { render } from "./ResourceCardGrid.vue?vue&type=template&id=2d2f57dd"
import script from "./ResourceCardGrid.vue?vue&type=script&lang=js"
export * from "./ResourceCardGrid.vue?vue&type=script&lang=js"

import "./ResourceCardGrid.vue?vue&type=style&index=0&id=2d2f57dd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__